import React, { useState } from "react";
import styles from "./Chinese.module.sass";
import Card from "../../../../../components/Card";
import classNames from "classnames";
import Switch from "../../../../../components/Switch";
import Popover2 from "../../../../../components/Popover2";
import { useDispatch, useSelector } from "react-redux";
import { fetchCards } from "../../../../../app/cards/cards.slice";
import TextInput from "../../../../../components/TextInput";
import { nanoid } from "nanoid";
import Modal from "../../../../../components/Modal";
import CardPreview from "../../../../../components/CardPreview";
import { HSK_LEVEL_COLORS } from "../../../../../utils/constants";

const characters = {
  character: "character",
  lineBreak: "SC",
  special: "SC",
  name: "name",
};

const SPECIAL_CARDS = [" ", ",", "，", "%", ":", ":", "：", "、"];
const LINE_BREAK_CARDS = ["。", ".", "!", "！", "?", "？", ";", "；"];

const LANGS = ["en", "es", "fr", "ru", "pt"];

const Chinese = ({
  chapter,
  editarCapitulo,
  editarFraseDeCapitulo,
  anadirFraseACapitulo,
  anadirCardAFrase,
  editarTraduccionDeFrase,
  eliminarFraseDeCapitulo,
  eliminarCardDeFrase,
  chapterIndexSelected,
  anadirCardDespuesDeOtra,
  cambiarCardDeFrase,
  myRefs,
  mode = "full", // "full" | "header" | "sentence"
  sentenceIndex,
  viewLevel = true,
  viewPinyin = true,
  selectedLevelFilter = "ALL",
  setViewLevel,
  setViewPinyin,
  openCardPopover,
  setOpenCardPopover,
  onCardTooltipHover,
}) => {
  const dispatch = useDispatch();

  const { cards } = useSelector((state) => state);

  const [isModalAddCard, setIsModalAddCard] = useState(false);

  const [isModalAddChar, setIsModalAddChar] = useState(false);

  const [isModalChangeSpecialCard, setIsModalChangeSpecialCard] = useState(false);

  const [isChangeCard, setIsChangeCard] = useState(false);

  const [selectedCard, setSelectedCard] = useState("");
  const [visibleModal, setVisibleModal] = useState(false);

  const [indiceFraseSelected, setIndiceFraseSelected] = useState(0);
  const [indiceCardSelected, setIndiceCardSelected] = useState(0);

  // Solo un popover abierto: en modo "sentence" usa el estado del padre; en modo "full" usa estado local
  const [openPopoverLocal, setOpenPopoverLocal] = useState(null);
  const isSentenceMode = mode === "sentence" && setOpenCardPopover != null;
  const openPopover = isSentenceMode ? openCardPopover : openPopoverLocal;
  const setOpenPopover = isSentenceMode ? setOpenCardPopover : setOpenPopoverLocal;

  // Row with visible hover tooltip (full mode): raise z-index so tooltip is above following rows
  const [hoveredCardRow, setHoveredCardRow] = useState(null);
  // Specific card hovered (full mode): raise wrapper z-index so tooltip is above sibling cards in same row
  const [hoveredCard, setHoveredCard] = useState(null);

  // Cards are fetched once by Content2 on mount; no per-instance fetch

  const handleSearchCard = (e) => {
    dispatch(
      fetchCards({
        take: 5,
        skip: 0,
        search: e,
      })
    );
  };

  function extraerNumero(str) {
    const resultado = str.match(/\d+/); // Esta expresión regular busca uno o más dígitos
    return resultado ? parseInt(resultado[0]) : null;
  }

  const handleGetColorLevel = (lvl) => {
    if (lvl?.title) {
      return HSK_LEVEL_COLORS?.[extraerNumero(lvl?.title)] || "#d3d3d3";
    }
    return "#d3d3d3";
  };

  const shouldShowLevelBar = (cardLevelTitle) => {
    if (selectedLevelFilter === "ALL") return true;
    return String(cardLevelTitle || "") === String(selectedLevelFilter || "");
  };

  const handleAddNewSentence = () => {
    let translations = [];

    LANGS.forEach((lang) => {
      translations.push({
        active: lang === "en" ? true : false,
        lang,
        trans: "",
      });
    });

    const uniqueObjects = { cards: [], processRawText: false, text: "", translations, id: nanoid() };

    anadirFraseACapitulo(chapterIndexSelected, uniqueObjects);
  };

  const handleMouseEnter = (e, index, i) => {
    setHoveredCardRow(index);
    setHoveredCard({ rowIndex: index, cardIndex: i });
    if (isSentenceMode && onCardTooltipHover) onCardTooltipHover(index);
    try {
      document.getElementById(`card_tooltip_${index}_${i}`).style.display = "block";
    } catch (err) {
      console.log(err);
    }
  };

  const handleMouseLeave = (e, index, i) => {
    setHoveredCardRow(null);
    setHoveredCard(null);
    if (isSentenceMode && onCardTooltipHover) onCardTooltipHover(null);
    try {
      document.getElementById(`card_tooltip_${index}_${i}`).style.display = "none";
    } catch (err) {
      console.log(err);
    }
  };

  if (mode === "header") {
    return (
      <div className={styles.headerOnly}>
        <span className="title-blue">Chinese</span>
      </div>
    );
  }

  if (mode === "sentence" && chapter?.sentences?.[sentenceIndex]) {
    const sentence = chapter.sentences[sentenceIndex];
    const index = sentenceIndex;
    return (
      <>
      <Modal outerClassName={styles.outer} visible={visibleModal} onClose={() => setVisibleModal(false)}>
        <div>
          <CardPreview card={selectedCard} />
        </div>
      </Modal>
      <Modal
        outerClassName={styles.outer}
        visible={isModalChangeSpecialCard}
        onClose={() => setIsModalChangeSpecialCard(false)}
      >
        <div>Select Special Char</div>
        <div
          className={classNames(styles.listSentence, styles.specialCharContainer)}
        >
          {SPECIAL_CARDS?.map((c, i) => (
            <div
              onClick={() => {
                cambiarCardDeFrase(chapterIndexSelected, indiceFraseSelected, indiceCardSelected, {
                  available: false,
                  card: null,
                  character: c,
                  suggestions: [],
                  type: "special",
                });
                setIsModalChangeSpecialCard(false);
              }}
              key={i}
              style={{ position: "relative" }}
            >
              <div tabIndex={i} style={{ transform: i === 0 ? "translateY(0.45em)" : "" }} className={styles.charCard}>
                <div className={styles.levelBar} style={{ backgroundColor: "#d3d3d3" }}></div>
                <div className={styles.scLabel}>SC</div>
                <div className={styles.charText}>{c}</div>
              </div>
            </div>
          ))}
          {LINE_BREAK_CARDS?.map((c, i) => (
            <div
              onClick={() => {
                cambiarCardDeFrase(chapterIndexSelected, indiceFraseSelected, indiceCardSelected, {
                  available: false,
                  card: null,
                  character: c,
                  suggestions: [],
                  type: "lineBreak",
                });
                setIsModalChangeSpecialCard(false);
              }}
              key={i}
              style={{ position: "relative" }}
            >
              <div tabIndex={i} style={{ transform: i === 0 ? "translateY(0.45em)" : "" }} className={styles.charCard}>
                <div className={styles.levelBar} style={{ backgroundColor: "#d3d3d3" }}></div>
                <div className={styles.scLabel}>SC</div>
                <div className={styles.charText}>{c}</div>
              </div>
            </div>
          ))}
        </div>
      </Modal>
      <Modal
        outerClassName={styles.outer}
        visible={isModalAddChar}
        onClose={() => setIsModalAddChar(false)}
      >
        <div className={styles.modalAddCharTitle}>Suggested word</div>
        <div>
          <TextInput
            type="text"
            required
            placeholder="Search card..."
            onChange={(e) => handleSearchCard(e.target.value)}
          />
          {cards?.value?.map((c, i) => (
            <div key={i} className={styles.cardListItem}>
              <div style={{ display: "flex", alignItems: "start" }}>
                <div className={styles.cardCharBox}>{c?.meaning?.character}</div>
                <div style={{ marginLeft: 20, width: "200px" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <b>{c?.meaning?.pinyin}</b>
                    <span className={styles.cardPinyinTone}>{c?.meaning?.pinyinTone}</span>
                  </div>
                  <div className={styles.cardTrans}>{c?.meaning?.trans}</div>
                </div>
              </div>
              <span
                onClick={() => {
                  anadirCardAFrase(chapterIndexSelected, index, {
                    available: true,
                    card: c,
                    character: c?.meaning?.character,
                    suggestions: [],
                  });
                  setIsModalAddChar(false);
                }}
                className={styles.linkAction}
              >
                + Add
              </span>
            </div>
          ))}
        </div>
      </Modal>
      <Modal outerClassName={styles.outer} visible={isModalAddCard} onClose={() => setIsModalAddCard(false)}>
        <div>
          <TextInput
            type="text"
            required
            placeholder="Search card..."
            onChange={(e) => handleSearchCard(e.target.value)}
          />
          {cards?.value?.map((c, i) => (
            <div
              key={i}
              className={styles.cardListItem}
            >
              <div style={{ display: "flex", alignItems: "start" }}>
                <div className={styles.cardCharBox}>
                  {c?.meaning?.character}
                </div>
                <div style={{ marginLeft: 20, width: "200px" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <b>{c?.meaning?.pinyin}</b>
                    <span className={styles.cardPinyinTone}>{c?.meaning?.pinyinTone}</span>
                  </div>
                  <div className={styles.cardTrans}>{c?.meaning?.trans}</div>
                </div>
              </div>
              <span
                onClick={() => {
                  if (isChangeCard) {
                    cambiarCardDeFrase(chapterIndexSelected, indiceFraseSelected, indiceCardSelected, {
                      available: true,
                      card: c,
                      character: c?.meaning?.character,
                      suggestions: [],
                    });
                  } else {
                    anadirCardDespuesDeOtra(chapterIndexSelected, indiceFraseSelected, indiceCardSelected, {
                      available: true,
                      card: c,
                      character: c?.meaning?.character,
                      suggestions: [],
                    });
                  }
                  setIsModalAddCard(false);
                }}
                className={styles.linkAction}
              >
                {isChangeCard ? "Change" : "+ Add"}
              </span>
            </div>
          ))}
        </div>
      </Modal>
      <div
        ref={(el) => (myRefs.current[index] = el)}
        className={classNames(styles.listSentence, styles.sentenceContainer)}
      >
        {sentence?.cards?.map((c, i) => (
          <div
            key={`${index}_${i}`}
            onMouseEnter={(e) => handleMouseEnter(e, index, i)}
            onMouseLeave={(e) => handleMouseLeave(e, index, i)}
            style={{ position: "relative" }}
          >
            <div
              id={`card_tooltip_${index}_${i}`}
              className={styles.cardTooltip}
              style={{ display: openPopover?.sentenceIndex === index && openPopover?.cardIndex === i ? "none" : undefined }}
            >
              <div style={{ display: "flex", fontSize: 14, alignItems: "center", justifyContent: "space-between" }}>
                <div className={styles.tooltipLabel}>TP</div>
                <div className={c?.card?.grammars?.[0]?.title ? styles.tooltipValue : styles.tooltipError}>
                  {c?.card?.grammars?.[0]?.title || "Err"}
                </div>
              </div>
              <div style={{ display: "flex", fontSize: 14, alignItems: "center", justifyContent: "space-between" }}>
                <div className={styles.tooltipLabel}>TR</div>
                <div
                  className={
                    c?.card?.meaning?.translations?.find((trans) => trans?.lang === "en")?.trans
                      ? styles.tooltipValue
                      : styles.tooltipError
                  }
                >
                  {c?.card?.meaning?.translations?.find((trans) => trans?.lang === "en")?.trans || "Err"}
                </div>
              </div>
              <div style={{ display: "flex", fontSize: 14, alignItems: "center", justifyContent: "space-between" }}>
                <div className={styles.tooltipLabel}>Level</div>
                <div className={c?.level?.title ? styles.tooltipValue : styles.tooltipError}>
                  {c?.level?.title || "Err"}
                </div>
              </div>
            </div>
            <Popover2
              up={index === (chapter?.sentences?.length - 1)}
              right
              portal
              visible={openPopover?.sentenceIndex === index && openPopover?.cardIndex === i}
              setVisible={(v) =>
                setOpenPopover(v ? { sentenceIndex: index, cardIndex: i } : null)
              }
              actionable={
                <div
                  tabIndex={i}
                  style={{ transform: i === 0 ? "translateY(0.45em)" : "" }}
                  className={styles.charCard}
                >
                  {viewLevel && shouldShowLevelBar(c?.level?.title) && (
                    <div
                      className={styles.levelBar}
                      style={{ backgroundColor: handleGetColorLevel(c?.level) || "#d3d3d3" }}
                    />
                  )}
                  {viewPinyin && (
                    <div
                      className={
                        c?.type === "name"
                          ? styles.pinyinName
                          : c?.card?.meaning?.pinyin
                          ? styles.pinyinText
                          : c?.type === "special" || c?.type === "lineBreak"
                          ? styles.scLabel
                          : styles.pinyinError
                      }
                    >
                      {c?.card?.meaning?.pinyin || characters?.[c?.type] || "Err"}
                    </div>
                  )}
                  <div className={styles.charText}>{c?.character}</div>
                </div>
              }
              items={[
                {
                  title: "Preview card",
                  icon: "expand",
                  action: () => {
                    setSelectedCard(c?.card);
                    setVisibleModal(true);
                  },
                },
                {
                  title: "Edit card",
                  icon: "edit",
                  action: () => {
                    setIsChangeCard(true);
                    setIndiceFraseSelected(index);
                    setIndiceCardSelected(i);
                    setIsModalAddCard(true);
                  },
                },
                {
                  title: "Convert Special",
                  icon: "edit",
                  action: () => {
                    setIndiceFraseSelected(index);
                    setIndiceCardSelected(i);
                    setIsModalChangeSpecialCard(true);
                  },
                },
                {
                  title: "Convert Noun",
                  icon: "edit",
                  action: () => {
                    cambiarCardDeFrase(chapterIndexSelected, index, i, {
                      available: false,
                      card: null,
                      character: `##${c?.character}##`,
                      suggestions: [],
                      type: "name",
                    });
                  },
                },
                {
                  title: "Delete card",
                  icon: "trash",
                  action: () => eliminarCardDeFrase(chapterIndexSelected, index, i),
                },
                {
                  title: "Add next card",
                  icon: "add",
                  action: () => {
                    setIsChangeCard(false);
                    setIndiceFraseSelected(index);
                    setIndiceCardSelected(i);
                    setIsModalAddCard(true);
                  },
                },
              ]}
            />
          </div>
        ))}
        <span
          className={styles.addCharLink}
          onClick={() => {
            setIndiceFraseSelected(index);
            setIsModalAddChar(true);
          }}
        >
          + Add char
        </span>
      </div>
      </>
    );
  }

  return (
    <>
      <Modal outerClassName={styles.outer} visible={visibleModal} onClose={() => setVisibleModal(false)}>
        <div>
          <CardPreview card={selectedCard} />
        </div>
      </Modal>
      <Modal
        outerClassName={styles.outer}
        visible={isModalChangeSpecialCard}
        onClose={() => setIsModalChangeSpecialCard(false)}
      >
        <div>Select Special Char</div>
        <div
          className={classNames(styles.listSentence, styles.specialCharContainer)}
        >
          {SPECIAL_CARDS?.map((c, i) => (
            <div
              onClick={() => {
                cambiarCardDeFrase(chapterIndexSelected, indiceFraseSelected, indiceCardSelected, {
                  available: false,
                  card: null,
                  character: c,
                  suggestions: [],
                  type: "special",
                });
                setIsModalChangeSpecialCard(false);
              }}
              key={i}
              style={{ position: "relative" }}
            >
              <div tabindex={i} style={{ transform: i === 0 ? "translateY(0.45em)" : "" }} className={styles.charCard}>
                <div className={styles.levelBar} style={{ backgroundColor: "#d3d3d3" }}></div>
                <div className={styles.scLabel}>SC</div>
                <div className={styles.charText}>{c}</div>
              </div>
            </div>
          ))}
          {LINE_BREAK_CARDS?.map((c, i) => (
            <div
              onClick={() => {
                cambiarCardDeFrase(chapterIndexSelected, indiceFraseSelected, indiceCardSelected, {
                  available: false,
                  card: null,
                  character: c,
                  suggestions: [],
                  type: "lineBreak",
                });
                setIsModalChangeSpecialCard(false);
              }}
              key={i}
              style={{ position: "relative" }}
            >
              <div tabindex={i} style={{ transform: i === 0 ? "translateY(0.45em)" : "" }} className={styles.charCard}>
                <div className={styles.levelBar} style={{ backgroundColor: "#d3d3d3" }}></div>
                <div className={styles.scLabel}>SC</div>
                <div className={styles.charText}>{c}</div>
              </div>
            </div>
          ))}
        </div>
      </Modal>
      <Modal
        outerClassName={styles.outer}
        visible={isModalAddChar}
        onClose={() => setIsModalAddChar(false)}
      >
        <div className={styles.modalAddCharTitle}>Suggested word</div>
        <div>
          <TextInput
            type="text"
            required
            placeholder="Search card..."
            onChange={(e) => handleSearchCard(e.target.value)}
          />
          {cards?.value?.map((c, i) => (
            <div key={i} className={styles.cardListItem}>
              <div style={{ display: "flex", alignItems: "start" }}>
                <div className={styles.cardCharBox}>{c?.meaning?.character}</div>
                <div style={{ marginLeft: 20, width: "200px" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <b>{c?.meaning?.pinyin}</b>
                    <span className={styles.cardPinyinTone}>{c?.meaning?.pinyinTone}</span>
                  </div>
                  <div className={styles.cardTrans}>{c?.meaning?.trans}</div>
                </div>
              </div>
              <span
                onClick={() => {
                  anadirCardAFrase(chapterIndexSelected, indiceFraseSelected, {
                    available: true,
                    card: c,
                    character: c?.meaning?.character,
                    suggestions: [],
                  });
                  setIsModalAddChar(false);
                }}
                className={styles.linkAction}
              >
                + Add
              </span>
            </div>
          ))}
        </div>
      </Modal>
      <Modal outerClassName={styles.outer} visible={isModalAddCard} onClose={() => setIsModalAddCard(false)}>
        <div>
          <TextInput
            type="text"
            required
            placeholder="Search card..."
            onChange={(e) => handleSearchCard(e.target.value)}
          />
          {cards?.value?.map((c, i) => (
            <div
              key={i}
              className={styles.cardListItem}
            >
              <div style={{ display: "flex", alignItems: "start" }}>
                <div className={styles.cardCharBox}>
                  {c?.meaning?.character}
                </div>
                <div style={{ marginLeft: 20, width: "200px" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <b>{c?.meaning?.pinyin}</b>
                    <span className={styles.cardPinyinTone}>{c?.meaning?.pinyinTone}</span>
                  </div>
                  <div className={styles.cardTrans}>{c?.meaning?.trans}</div>
                </div>
              </div>
              <span
                onClick={() => {
                  if (isChangeCard) {
                    cambiarCardDeFrase(chapterIndexSelected, indiceFraseSelected, indiceCardSelected, {
                      available: true,
                      card: c,
                      character: c?.meaning?.character,
                      suggestions: [],
                    });
                  } else {
                    anadirCardDespuesDeOtra(chapterIndexSelected, indiceFraseSelected, indiceCardSelected, {
                      available: true,
                      card: c,
                      character: c?.meaning?.character,
                      suggestions: [],
                    });
                  }
                  setIsModalAddCard(false);
                }}
                className={styles.linkAction}
              >
                {isChangeCard ? "Change" : "+ Add"}
              </span>
            </div>
          ))}
        </div>
      </Modal>
      <Card
        title="Chinese"
        classTitle="title-blue"
        head={
          <div style={{ display: "flex", alignItems: "center" }} className={classNames(styles.nav, "tablet-hide")}>
            <div style={{ display: "flex", alignItems: "center", marginRight: 30 }}>
              <span style={{ marginRight: 10 }}>View level</span>
              <Switch value={viewLevel} onChange={() => setViewLevel?.(!viewLevel)} />
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <span style={{ marginRight: 10 }}>View pinyin</span>
              <Switch value={viewPinyin} onChange={() => setViewPinyin?.(!viewPinyin)} />
            </div>
          </div>
        }
      >
        <div style={{ minHeight: "65vh" }} className={styles.listSentence}>
          {chapter.sentences?.map((sentence, index) => (
            <div
              ref={(el) => (myRefs.current[index] = el)}
              key={index}
              className={classNames(styles.listSentence, styles.sentenceContainer, hoveredCardRow === index && styles.sentenceContainerTooltipVisible)}
            >
              {sentence?.cards?.map((c, i) => (
                <div
                  key={`${index}_${i}`}
                  onMouseEnter={(e) => handleMouseEnter(e, index, i)}
                  onMouseLeave={(e) => handleMouseLeave(e, index, i)}
                  className={classNames(hoveredCard?.rowIndex === index && hoveredCard?.cardIndex === i && styles.cardWrapperTooltipVisible)}
                  style={{ position: "relative" }}
                >
                  <div
                    id={`card_tooltip_${index}_${i}`}
                    className={styles.cardTooltip}
                    style={{ display: openPopover?.sentenceIndex === index && openPopover?.cardIndex === i ? "none" : undefined }}
                  >
                    <div
                      style={{ display: "flex", fontSize: 14, alignItems: "center", justifyContent: "space-between" }}
                    >
                      <div className={styles.tooltipLabel}>TP</div>
                      <div className={c?.card?.grammars?.[0]?.title ? styles.tooltipValue : styles.tooltipError}>
                        {c?.card?.grammars?.[0]?.title || "Err"}
                      </div>
                    </div>
                    <div
                      style={{ display: "flex", fontSize: 14, alignItems: "center", justifyContent: "space-between" }}
                    >
                      <div className={styles.tooltipLabel}>TR</div>
                      <div
                        className={c?.card?.meaning?.translations?.find((trans) => trans?.lang === "en")?.trans
                            ? styles.tooltipValue
                            : styles.tooltipError}
                      >
                        {c?.card?.meaning?.translations?.find((trans) => trans?.lang === "en")?.trans || "Err"}
                      </div>
                    </div>
                    <div
                      style={{ display: "flex", fontSize: 14, alignItems: "center", justifyContent: "space-between" }}
                    >
                      <div className={styles.tooltipLabel}>Level</div>
                      <div className={c?.level?.title ? styles.tooltipValue : styles.tooltipError}>{c?.level?.title || "Err"}</div>
                    </div>
                  </div>
                  <Popover2
                    up={index === (chapter?.sentences?.length - 1)}
                    right
                    portal
                    visible={openPopover?.sentenceIndex === index && openPopover?.cardIndex === i}
                    setVisible={(v) =>
                      setOpenPopover(v ? { sentenceIndex: index, cardIndex: i } : null)
                    }
                    actionable={
                      <div
                        tabindex={i}
                        style={{ transform: i === 0 ? "translateY(0.45em)" : "" }}
                        className={styles.charCard}
                      >
                        {viewLevel && shouldShowLevelBar(c?.level?.title) && (
                          <div
                            className={styles.levelBar}
                            style={{
                              backgroundColor: handleGetColorLevel(c?.level) || "#d3d3d3",
                            }}
                          ></div>
                        )}
                        {viewPinyin && (
                          <div
                            className={
                              c?.type === "name"
                                ? styles.pinyinName
                                : c?.card?.meaning?.pinyin
                                ? styles.pinyinText
                                : c?.type === "special" || c?.type === "lineBreak"
                                ? styles.scLabel
                                : styles.pinyinError
                            }
                          >
                            {c?.card?.meaning?.pinyin || characters?.[c?.type] || "Err"}
                          </div>
                        )}
                        <div className={styles.charText}>
                          {c?.character}
                        </div>
                      </div>
                    }
                    items={[
                      {
                        title: "Preview card",
                        icon: "expand",
                        action: () => {
                          setSelectedCard(c?.card);
                          setVisibleModal(true);
                        },
                      },
                      {
                        title: "Edit card",
                        icon: "edit",
                        action: () => {
                          setIsChangeCard(true);
                          setIndiceFraseSelected(index);
                          setIndiceCardSelected(i);
                          setIsModalAddCard(true);
                        },
                      },
                      {
                        title: "Convert Special",
                        icon: "edit",
                        action: () => {
                          setIndiceFraseSelected(index);
                          setIndiceCardSelected(i);
                          setIsModalChangeSpecialCard(true);
                        },
                      },
                      {
                        title: "Convert Noun",
                        icon: "edit",
                        action: () => {
                          cambiarCardDeFrase(chapterIndexSelected, index, i, {
                            available: false,
                            card: null,
                            character: `##${c?.character}##`,
                            suggestions: [],
                            type: "name",
                          });
                        },
                      },
                      {
                        title: "Delete card",
                        icon: "trash",
                        action: () => eliminarCardDeFrase(chapterIndexSelected, index, i),
                      },
                      {
                        title: "Add next card",
                        icon: "add",
                        action: () => {
                          setIsChangeCard(false);
                          setIndiceFraseSelected(index);
                          setIndiceCardSelected(i);
                          setIsModalAddCard(true);
                        },
                      },
                    ]}
                  />
                </div>
              ))}
              <span
                className={styles.addCharLink}
                onClick={() => {
                  setIndiceFraseSelected(index);
                  setIsModalAddChar(true);
                }}
              >
                + Add char
              </span>
            </div>
          ))}
          <div
            onClick={handleAddNewSentence}
            className={styles.addSentenceLink}
          >
            + Add new sentence
          </div>
        </div>
      </Card>
    </>
  );
};

export default React.memo(Chinese);
